var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstalledBaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.25C7.41421 1.25 7.75 1.58579 7.75 2V3.25H16.25V2C16.25 1.58579 16.5858 1.25 17 1.25C17.4142 1.25 17.75 1.58579 17.75 2V3.25H19C20.5142 3.25 21.75 4.48579 21.75 6V11C21.75 11.4142 21.4142 11.75 21 11.75C20.5858 11.75 20.25 11.4142 20.25 11V6C20.25 5.31421 19.6858 4.75 19 4.75H17.75V6C17.75 6.41421 17.4142 6.75 17 6.75C16.5858 6.75 16.25 6.41421 16.25 6V4.75H7.75V6C7.75 6.41421 7.41421 6.75 7 6.75C6.58579 6.75 6.25 6.41421 6.25 6V4.75H5C4.31421 4.75 3.75 5.31421 3.75 6V20C3.75 20.6858 4.31421 21.25 5 21.25H19C19.6858 21.25 20.25 20.6858 20.25 20V15C20.25 14.5858 20.5858 14.25 21 14.25C21.4142 14.25 21.75 14.5858 21.75 15V20C21.75 21.5142 20.5142 22.75 19 22.75H5C3.48579 22.75 2.25 21.5142 2.25 20V6C2.25 4.48579 3.48579 3.25 5 3.25H6.25V2C6.25 1.58579 6.58579 1.25 7 1.25ZM12 8.45C12.4142 8.45 12.75 8.78579 12.75 9.2V14.8893L14.6697 12.9697C14.9626 12.6768 15.4374 12.6768 15.7303 12.9697C16.0232 13.2626 16.0232 13.7374 15.7303 14.0303L12.5303 17.2303C12.2374 17.5232 11.7626 17.5232 11.4697 17.2303L8.26967 14.0303C7.97678 13.7374 7.97678 13.2626 8.26967 12.9697C8.56256 12.6768 9.03744 12.6768 9.33033 12.9697L11.25 14.8893V9.2C11.25 8.78579 11.5858 8.45 12 8.45Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstalledBaseIcon);
export default __webpack_public_path__ + "static/media/installed_base_icon.1582c15d31728021166d0cfafd422967.svg";
export { ForwardRef as ReactComponent };